export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/file-054a62e005c65673b61183f2786a1ab5.svg";